import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel } from '../../shared';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})

export class EntityMergingService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-merging/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-merging/backoffice-ep'
    this.httpClient = http;
  }

  getByFilterCriteria(
    filterCriteria: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/' + filterCriteria,
      this.getHttpHeader(visa)
    );
  }
  
  getByFilterCriteriaByCustomer(
    filterCriteria: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/suggestion/customers/' + filterCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByFilterCriteriaBySupplier(
    filterCriteria: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/suggestion/suppliers/' + filterCriteria,
      this.getHttpHeader(visa)
    );
  }

  //  NAME("\"name\""),
  //   ID_NO("id_no"),
  //   PHONE("phone"),
  //   EMAIL("email");


}
